import "@wilco/ui/styles.css";
import "./app.css";
import "./stock/stock.css";
import "./purchasing/purchasing.css";
import "./production/production.css";
import "./catalog/catalog.css";
import "./money.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { ToastProvider } from "@wilco/ui";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { t } from "./i18n.ts";
import { makeRouter } from "./router.tsx";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false },
  },
});

const router = makeRouter(queryClient);

const root = document.getElementById("root");
if (!root) throw new Error("нет #root");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider closeLabel={t("shell.close")} regionLabel={t("shell.toasts")}>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
